import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { COMPANY } from "@/lib/company";

let _logoP = null;
function loadLogo() {
  if (_logoP) return _logoP;
  _logoP = fetch(COMPANY.logoUrl)
    .then((r) => r.blob())
    .then((b) => new Promise((res, rej) => {
      const fr = new FileReader();
      fr.onload = () => res(fr.result);
      fr.onerror = () => rej(fr.error);
      fr.readAsDataURL(b);
    }))
    .catch(() => null);
  return _logoP;
}

async function header(doc, title) {
  const pageW = doc.internal.pageSize.getWidth();
  const margin = 40;
  const logo = await loadLogo();
  if (logo) {
    try { doc.addImage(logo, "PNG", margin, 14, 77, 77); } catch (e) { /* noop */ }
  }
  const companyX = margin + 84;
  const companyMaxW = pageW - margin - 84;

  // Auto-fit company name (single line + underline)
  doc.setTextColor(10, 10, 10);
  doc.setFont("helvetica", "bold");
  let size = 14;
  while (size > 8 && doc.getTextWidth((doc.setFontSize(size), COMPANY.legalName)) > companyMaxW) {
    size -= 0.5;
    doc.setFontSize(size);
  }
  doc.setFontSize(size);
  const nameY = 32;
  doc.text(COMPANY.legalName, companyX, nameY);
  const nw = doc.getTextWidth(COMPANY.legalName);
  doc.setDrawColor(10, 10, 10); doc.setLineWidth(0.8);
  doc.line(companyX, nameY + 3, companyX + nw, nameY + 3);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  const RIGHT_W = 150;
  const leftMaxW = pageW - margin - 84 - RIGHT_W - 12;
  const addrLines = doc.splitTextToSize(COMPANY.address, leftMaxW);
  const row1 = nameY + 22;
  doc.text(addrLines, companyX, row1);
  const afterAddr = row1 + addrLines.length * 11;
  doc.text(`Contact: ${COMPANY.contact1} / ${COMPANY.contact2}   ·   Customer Care: ${COMPANY.customerCare}`, companyX, afterAddr);
  doc.text(`${COMPANY.email}   ·   GST: ${COMPANY.gst}`, companyX, afterAddr + 11);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text(title, pageW - margin, row1, { align: "right" });
  doc.setFont("helvetica", "normal");
  doc.text(new Date().toLocaleString(), pageW - margin, row1 + 12, { align: "right" });

  doc.setDrawColor(10, 10, 10); doc.setLineWidth(1.2);
  doc.line(margin, 130, pageW - margin, 130);
}

export async function buildCustomersPdf(rows) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  await header(doc, `CUSTOMER LIST · ${rows.length}`);
  autoTable(doc, {
    startY: 150,
    margin: { left: 40, right: 40 },
    head: [["Name", "City", "Phone", "Agent"]],
    body: rows.map((r) => [r.name || "", r.city || "", r.phone || "", r.agent || ""]),
    styles: { font: "helvetica", fontSize: 10, cellPadding: 6, lineColor: [10, 10, 10], lineWidth: 0.5, textColor: [10, 10, 10] },
    headStyles: { fillColor: [10, 10, 10], textColor: [255, 255, 255], fontStyle: "bold" },
  });
  return doc.output("blob");
}

export async function buildAgentsPdf(rows) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  await header(doc, `AGENT LIST · ${rows.length}`);
  autoTable(doc, {
    startY: 150,
    margin: { left: 40, right: 40 },
    head: [["Name", "Phone", "Updated"]],
    body: rows.map((r) => [r.name || "", r.phone || "", r.updated_at ? new Date(r.updated_at).toLocaleDateString() : "—"]),
    styles: { font: "helvetica", fontSize: 10, cellPadding: 6, lineColor: [10, 10, 10], lineWidth: 0.5, textColor: [10, 10, 10] },
    headStyles: { fillColor: [10, 10, 10], textColor: [255, 255, 255], fontStyle: "bold" },
  });
  return doc.output("blob");
}

export async function downloadMastersPdf(kind, rows) {
  const blob = kind === "customers" ? await buildCustomersPdf(rows) : await buildAgentsPdf(rows);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = `${kind}-master.pdf`;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function downloadMastersCsv(kind, rows) {
  const cols = kind === "customers"
    ? ["name", "city", "phone", "agent"]
    : ["name", "phone", "updated_at"];
  const lines = [cols.join(",")].concat(
    rows.map((r) => cols.map((c) => `"${String(r[c] ?? "").replace(/"/g, '""')}"`).join(","))
  ).join("\n");
  const blob = new Blob([lines], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = `${kind}-master.csv`;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
